import { close_page } from '@kk/h5-sdk';
import { ua } from '@kk/utils';
import { miniNav } from './miniNav';

export function closePage(options) {
    if (ua.miniprogram) {
        console.info('准备小程序关闭');
        miniNav('', {
            mini_action_type: 'navigateBack',
        });
    } else {
        close_page(options);
    }
}
